module.exports = __webpack_public_path__ + "static/images/stage.320248f89.png";